import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';
import { posted } from 'shared/helpers/moment';
import { phoneNormalize } from 'shared/modules';
import Price from 'desktop/components/PriceBlock/Price';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import { withTranslate } from 'shared/hocs/withTranslate';
import currencies from 'shared/constants/json/currency.json';
import { getNodeStringContents } from 'shared/helpers/react';
import { stripMultipleSpaces } from 'shared/helpers/strings';
import { setNextSearchItemIndex } from 'shared/actions/history';
import withAdvertPhoneView from 'shared/hocs/withAdvertPhoneView';
import AgencyInfo from 'desktop/components/AgencyInfo/AgencyInfo';
import { getPriceWithCurrency } from 'shared/helpers/transportInfo';
import { getSpareDefaultImage } from 'shared/constants/defaultImages';

import imgArrow from 'shared/assets/images/right-arrow-angle.svg';

import Thumb from '../Thumb/Thumb';
import s from './SparepartItem.css';

const IMAGE_WIDTH = 228;

class SparepartItem extends React.Component {
  static propTypes = {
    advert: PropTypes.shape({
      title: PropTypes.string,
      id: PropTypes.number,
      price: PropTypes.arrayOf(PropTypes.shape()),
      location: PropTypes.shape(),
      models: PropTypes.arrayOf(PropTypes.shape()),
      photos: PropTypes.arrayOf(PropTypes.shape()),
      rubric: PropTypes.shape(),
      sparetypes: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
    setRatioImage: PropTypes.func.isRequired,
    selectedCurrency: PropTypes.shape(),
    requestShowPhones: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    isProfile: PropTypes.bool,
    canEdit: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    advertID: PropTypes.number,
    phones: PropTypes.arrayOf(PropTypes.string),
    sold: PropTypes.bool,
    active: PropTypes.number,
    agency: PropTypes.shape(),
    isApprovePub: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    isProfile: false,
    agencyParams: null,
    canEdit: false,
    selectedCurrency: currencies[0],
    title: '',
    phones: null,
    sold: false,
    isApprovePub: false,
    active: 1,
    advertID: null,
    agency: null,
  };

  handleShowPhoneClick = () => {
    const advertID = this.props.advert.id;
    if (advertID) {
      this.props.requestShowPhones(advertID);
    }
  };

  render() {
    const {
      token,
      isProfile,
      advert,
      intl,
      selectedCurrency,
      canEdit,
      setRatioImage,
      phones,
      sold,
      active,
      isApprovePub,
    } = this.props;
    const {
      title,
      photos,
      models,
      price,
      rubric,
      hot_date: hotDate,
      date_published: published,
      color_date: colorDate,
      date_created: created,
      sparetypes,
      location,
      permalink,
      id,
      agency,
    } = advert;

    const { locale } = intl;
    const date = hotDate || published || created;
    const link = permalink || `/zapchasti/${id}/`;

    const shouldEmphasizePrice = colorDate ? new Date(colorDate) > new Date() : false;
    const isTop = new Date() < new Date(advert.top_date);
    const agencyParams = agency
      ? {
          logo: agency.logo ? agency.logo.replace('http:', 'https:') : '',
          link: agency.slug ? `/katalog-kompaniy/${agency.slug}` : null,
          name: agency.title ? agency.title : '',
        }
      : null;

    const isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
    return (
      <div className={s.root}>
        <div className={s.wrapper}>
          <Link to={link} className={s.link} />
          <div className={s.left}>
            <Thumb
              width={IMAGE_WIDTH}
              link={link}
              photos={photos.length > 0 ? photos : []}
              defaultImg={getSpareDefaultImage()}
              alt={
                this.props.title
                  ? `${stripMultipleSpaces(
                      getNodeStringContents(this.props.title),
                    )} - ${intl.formatMessage({
                      id: 'купить на Автобазаре',
                    })}`
                  : ''
              }
            />
          </div>

          <div className={s.right}>
            <div className={s.info}>
              <div>
                <div className={s.brand}>
                  {title}
                </div>
                {models.length > 0 &&
                  <div className={s.details}>
                    {models
                      .filter(model => model && model.slug && model.title)
                      .map(({ id: compatibilityId, title: model }, i, { length }) =>
                        <span key={compatibilityId}>
                          {model}
                          {i !== length - 1 ? ', ' : ''}
                        </span>,
                      )}
                  </div>}
              </div>
              <div>
                <div className={s.details}>
                  <div className={s.rubric}>
                    <div className={cx(s.sparetypes, s.mainSpareRubric)}>
                      {rubric.title}{' '}
                      {rubric &&
                        rubric.title &&
                        sparetypes.length > 0 &&
                        <img src={imgArrow} width="8" height="8" className={s.arrowImg} alt="" />}
                    </div>
                    {sparetypes.length > 0 &&
                      sparetypes.map(({ title: typeTitle, id: typeId }) =>
                        <div className={s.sparetypes} key={typeId}>
                          {typeTitle}
                        </div>,
                      )}
                  </div>
                </div>
              </div>
              <div className={s.infoListing}>
                {agencyParams &&
                  agencyParams.link &&
                  <AgencyInfo
                    title={agencyParams.name}
                    link={agencyParams.link}
                    src={setRatioImage(agencyParams.logo, 40)}
                  />}
                <div className={s.bottomSection}>
                  <div className={s.place}>
                    {location && location.title}
                    {location && location.title && date && ', '}
                    {date &&
                      <span>
                        {posted(date, locale)}
                      </span>}
                  </div>
                  {canEdit &&
                    <Link to={`/edit-parts/${id}/`} className={s.editLink}>
                      <FormattedMessage id="Редактировать" />
                    </Link>}
                </div>
              </div>
            </div>
            <div className={s.pricePhone}>
              <div className={s.priceWrapper}>
                <div className={s.price}>
                  {price.some(p => p.value) && getPriceWithCurrency(price, selectedCurrency.slug)
                    ? <Price
                        shouldEmphasizePrice={shouldEmphasizePrice}
                        setRatioImage={setRatioImage}
                        advertID={id}
                        isTop={isTop}
                        price={price}
                        token={token}
                        intl={intl}
                        isSparepart
                        isProfile={isProfile}
                      />
                    : <span className={s.priceVal}>
                        {intl.formatMessage({ id: 'договорная' })}
                      </span>}
                </div>
              </div>
              <div className={s.phone}>
                {!isDeactivated &&
                  <div className={s.contact}>
                    <div
                      className={cx(s.contactBtn, { [s.showedPhone]: phones && phones.length > 0 })}
                      onClick={this.handleShowPhoneClick}
                    >
                      {phones &&
                        !phones.length &&
                        <div>
                          <FormattedMessage id="Нет телефонов" />
                        </div>}
                      {phones &&
                        phones.length > 0 &&
                        phones.map(phone =>
                          <div key={phone} className={cx(s.phoneList, s.phone)}>
                            <a href={`tel:${phoneNormalize(phone)}`}>
                              {phoneNormalize(phone)}
                            </a>
                          </div>,
                        )}
                      {!phones &&
                        <div>
                          <div data-lens-event="showPhoneClick">
                            <FormattedMessage id="Показать телефон" />
                          </div>
                          +••• •• ••• •• ••
                        </div>}
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals, user }) => ({
  locale: globals.locale,
  token: user && user.token,
});

const mapDispatchToProps = {
  setNextSearchItemIndex,
};

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(
    withAdvertPhoneView(withTranslate(withPixelRatio(SparepartItem))),
  ),
);



// WEBPACK FOOTER //
// ./src/desktop/components/SparepartItem/SparepartItem.js